import { Button } from "antd";
import React, { memo, useState } from "react";
import { useMakeQueriesMutation } from "../../service/apiSlices/sematicModel";
import { useNavigate } from "react-router-dom";
import { showErrorToast, showInfoToast } from "../../utilities/toastUtils";
import { ROUTES, TOKENS } from "../../utilities/Constants/Constants";
import { useQueryGeneratorContext } from "../../context/QueryBuilder/QueryGeneratorContext";
import { useWorkbenchContext } from "../../context/WorkbenchContext";


const ProceedSemantic = () => {
  const {workBenchData} = useWorkbenchContext()

  const connection_Id = sessionStorage.getItem(TOKENS.CONNECTION_ID);

  const navigate = useNavigate();
  
  const { tableQueryDataMap, selectedTableNames } = useQueryGeneratorContext();
  const modelName = workBenchData?.workbench_name;
  const secretKey = workBenchData?.secret_key || null;
  
  const [loading, setLoading] = useState(false);
  
  const [makeQuery] = useMakeQueriesMutation();

  const handleOnNextClick = () => {
    if (!modelName) return showInfoToast("Please provide a Model Name, as the generated model will appear under this name.");
    if (!secretKey)return showErrorToast("Something went wrong. Please try after sometime");
    if (selectedTableNames.length < 1) return showInfoToast("Please select at least one table to proceed.");

    handleQuerySave();
  };

  const handleQuerySave = () => {
    setLoading(true);

    const columns = selectedTableNames.reduce((acc: any, tableName: string) => {
      const tableItem = tableQueryDataMap[tableName]
      acc[tableName] = {
        'selected_columns': tableItem.columns,
        'is_all_columns_selected': tableItem.isAllColumnsSelected,
      };
      return acc
    }, {})
    
    const queryFramePayload = {
      secret_key: secretKey,
      connection_key: connection_Id,
      tables: selectedTableNames,
      columns,
    };

    makeQuery(queryFramePayload)
      .unwrap()
      .then((response: any) => {
        if (response.status_code === 200) {
          setLoading(false);
          navigate(`${ROUTES.PINBOARD}/${secretKey}`);
        }
      })
      .catch((err: any) => {
        setLoading(false);
        console.error("Error in query frame:", err);
      });
  };

  return (
    <div>
      <Button
        className={"querybuilder-btn-default"}
        onClick={handleOnNextClick}
        loading={loading}
        disabled={loading}
      >
        Proceed to Next
      </Button>
    </div>
  );
};

export default memo(ProceedSemantic);
